import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

export const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear()

    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-main">
                    <div className="footer-section">
                        <h3>Modern Artillery Group</h3>
                        <div className="footer-contact">
                            <p><strong>Contact:</strong></p>
                            <p><a href="mailto:staff@modernartillerygroup.com">staff@modernartillerygroup.com</a></p>
                        </div>
                    </div>
                </div>

                <div className="footer-bottom">
                    <div className="footer-bottom-content">
                        <div className="footer-copyright">
                            <p>&copy; {currentYear} Modern Artillery Group. All rights reserved.</p>
                        </div>
                        <div className="footer-legal">
                            <Link to="/privacy">Privacy Policy</Link>
                            <Link to="/terms">Terms of Service</Link>
                            <Link to="/cookies">Cookie Policy</Link>
                        </div>
                    </div>
                    <div className="footer-powered-by">
                        <p>Powered by: <strong>Good Friends, Bad Times</strong></p>
                    </div>
                </div>
            </div>
        </footer>
    )
}
